module.exports = __webpack_public_path__ + "static/media/2_en.bb906f3b.png";